import React from 'react'
import { connect } from 'react-redux'
import { fetchLabels } from '../actions/labels'
import { selectItems } from '../actions/lists'
import { fetchPromos } from '../actions/promos'
import { fetchServices } from '../actions/services'

function mapStateToProps(state, props) {
    const { entities, result, isFetching, filters } = state.promos || {}
    const filter = filters && filters[props.filterId]
    const searchKey = filter && filter.searchKey
    const servicesEntities = state.services?.entities || {}
    const labelsEntities = state.labels?.entities || {}

    return {
        pages: (result && result[searchKey]) || {},
        entities: {
            ...entities,
            services: servicesEntities.services || {},
            labels: labelsEntities.labels || {},
        },
        filter,
        isFetching: isFetching || false,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        select: (ids, filterId) => dispatch(selectItems('promos', ids, filterId)),
        fetchServices: (filterId) => dispatch(fetchServices(filterId)),
        fetchLabels: (options) => dispatch(fetchLabels(options)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)
